import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ITeacherDetail } from 'core/hooks';

import * as S from '../../FakturowniaInvoices/FakturowniaInvoices.styled';

interface IOverviewTabProps {
  teacher: ITeacherDetail;
}

export const OverviewTab = memo(({ teacher }: IOverviewTabProps) => {
  const { t } = useTranslation();
  const courses = (teacher.courses || []).filter(Boolean).join(', ');

  return (
    <S.Card>
      <S.CardTitle>
        {t('pages.teacherDetail.overview.contactSection')}
      </S.CardTitle>
      <S.Row>
        <S.RowLabel>{t('pages.teacherDetail.overview.email')}</S.RowLabel>
        <S.RowValue>{teacher.user?.email || '—'}</S.RowValue>
      </S.Row>
      <S.Row>
        <S.RowLabel>{t('pages.teacherDetail.overview.phone')}</S.RowLabel>
        <S.RowValue>{teacher.user?.phone || '—'}</S.RowValue>
      </S.Row>
      <S.Row>
        <S.RowLabel>{t('pages.teacherDetail.overview.courses')}</S.RowLabel>
        <S.RowValue>{courses || '—'}</S.RowValue>
      </S.Row>
      <S.Row>
        <S.RowLabel>{t('pages.teacherDetail.overview.lmsAccess')}</S.RowLabel>
        <S.RowValue>
          {teacher.accessToLms
            ? t('pages.teacherDetail.overview.yes')
            : t('pages.teacherDetail.overview.no')}
        </S.RowValue>
      </S.Row>
      <S.Row>
        <S.RowLabel>{t('pages.teacherDetail.overview.dismissed')}</S.RowLabel>
        <S.RowValue>
          {teacher.isDismissed
            ? t('pages.teacherDetail.overview.yes')
            : t('pages.teacherDetail.overview.no')}
        </S.RowValue>
      </S.Row>
    </S.Card>
  );
});
